module.exports = __webpack_public_path__ + "img/AddAlarmOutlined.c34f6380.svg";